import { trpc } from '../trpc'

export const subscriptionHooks = {
  useGetById: (id?: number) => {
    return trpc.subscription.getById.useQuery({ id: id! }, { enabled: !!id })
  },
}
